module.exports = __webpack_public_path__ + "img/one_txt.84ae8200.png";